module.exports = __webpack_public_path__ + "static/img/login_desc1.fff80b4b.png";